export default __webpack_public_path__ + "static/media/notepad.80183118.png";